import * as EditorFunctions from './EditorFunctions';


export function goToLocation(screenPath, loc, feOrPuSet, changeTab, setIsShowingSomeDropDown, setItemEdited, screenRefs, leftColRefs, flashHighlight, setFlashHighlight, color, currentList, centerZoom, fakeInternalVariables){

  function doBlinks(){
    var myRef = screenRefs[screenPath.join('_')];
    if (myRef && myRef.current){
      myRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    if (!flashHighlight){
      var screenPathString = screenPath.join(' ');
      for (var i = 0; i < 3; i++){
        setTimeout(function(){ setFlashHighlight({screenPathString, color, i:1}); }, i * 1000);
        setTimeout(function(){ setFlashHighlight({screenPathString, color, i:0}); }, i * 1000 + 500);
      }
      setTimeout(function(){ setFlashHighlight(false); }, 3000);
    }
  }

  if (loc.join(' ') === 'noDefaultScreen'){
    doBlinks();
    centerZoom();
  }else if (screenPath.length === 0){
    changeTab('Overall', 4);
  }else if (screenPath[0] === 'mu'){
    changeTab('Overall', 3);
  }else if (screenPath[0] === 'fe' || screenPath[0] === 'pu' || screenPath[0] === 'cn'){
    centerZoom();
    if (screenPath.length === 1){
    }else{

      if (screenPath[0] === 'cn'){
        var haveFound6 = false;
        if (feOrPuSet){
          var p15 = [feOrPuSet.t, feOrPuSet.v, 'nv'];
          openNavBar(p15);
        }else{
          var i2Set = ['fe', 'pu'];
          for (var i2 = 0; i2 < i2Set.length; i2 ++){
            var thisI2 = i2Set[i2];
            var fe = currentList[thisI2];
            var feKeys = Object.keys(fe);
            for (var i3 = 0; i3 < feKeys.length; i3++){
              var anFEKey = feKeys[i3];
              var thisFE = fe[anFEKey];
              if (thisFE.nv && thisFE.nv.on === screenPath[1]){
                var p14 = [thisI2, anFEKey, 'nv'];
                openNavBar(p14);
                haveFound6 = true;
                break;
              }
            }
            if (haveFound6){
              break;
            }
          }
        }

        if (screenPath.length === 3){
          return;
        }
      }

      function openNavBar(path){
        fakeInternalVariables.otherInfo[path.join('_')] = true;
        fakeInternalVariables.setOtherInfo({...fakeInternalVariables.otherInfo})

        if (screenPath.length === 3){
          setItemEdited({t:'navBar', path});
          changeTab('ElementStyle', 0);
        }
      }

        //also do overallStyleChecks for this.
      

      if (screenPath.length > 2){
        if (screenPath[2] === '_s' || screenPath[2] === 'nv'){
          var errorPart = EditorFunctions.getErrorPart(loc, screenPath);
          if (loc[0] === 'as'){
            setItemEdited({t:'asset',path:['as', loc[1]],screenPath});

            var thisEle = document.getElementById(loc[1]);
            if (thisEle){
              var assetStyle = thisEle.style;
              var origBackgroundColor = assetStyle.backgroundColor;

              for (var i1 = 0; i1 < 3; i1++){
                setTimeout(function(){ assetStyle.backgroundColor = color; }, i1 * 1000);
                setTimeout(function(){ assetStyle.backgroundColor = 'white'; }, i1 * 1000 + 500);
              }
              setTimeout(function(){ assetStyle.backgroundColor = origBackgroundColor; }, 3000);
            }else{
              doBlinks();
            }
          }else if (screenPath.length === 4){
            setItemEdited({t:'screen',path:screenPath})
            changeTab('ElementStyle', 0);
            doBlinks();
          }else if (screenPath[4] === 'al'){
            setItemEdited({t:'alert',path:screenPath})
            doBlinks();
          }else if (screenPath.length === 3 && screenPath[2] === 'nv'){
            setItemEdited({t:'navBar',path:screenPath});
            changeTab('ElementStyle', 0);
            doBlinks();
          }else{
            setItemEdited({t:'item',path:screenPath});
            doBlinks();
          }
          if (errorPart[0] === 'oc'){
            setIsShowingSomeDropDown({t:errorPart[1]});
          }else if (errorPart[0] === 's'){
            var whichStyle = errorPart[1];
            var leftRR = leftColRefs[loc.join(' ')];
            if (leftRR && leftRR.current){
              leftRR.current.scrollIntoView({ behavior: 'smooth' });
            }
            if (whichStyle === 'text'){
              setIsShowingSomeDropDown({t:'text'});
            }else if (whichStyle === 'borderWidth' || whichStyle === 'borderColor' || whichStyle === 'borderRadius' || whichStyle === 'borderStyle' || whichStyle === 'borderTopLeftRadius' || whichStyle === 'borderTopRightRadius' || whichStyle === 'borderBottomLeftRadius' || whichStyle === 'borderBottomRightRadius'){
              setIsShowingSomeDropDown({t:'border'});
            }else if (whichStyle === 'backgroundColor'){
              setIsShowingSomeDropDown({t:'colorSet', colors:[{t:'Background', i:'backgroundColor', f:1}]})
            }else if (whichStyle === 'color'){
              setIsShowingSomeDropDown({t:'color'})
            }else{
              setIsShowingSomeDropDown({t:'style'});
            }
          }
          // console.log(errorPart);
        }else{
          setItemEdited({t:'page', path:[screenPath[0], screenPath[1]]});
          // console.warn(error);
        }
      }else{
        doBlinks();
      }
    }
  }else if (screenPath[0] === 'ov'){
      changeTab('Definitions', 0);
  }else if (screenPath[0] === 'sc'){
      changeTab('Contracts', 0);
  }else if (screenPath[0] === 'mt'){
      changeTab('For Sam', 0);

  }else{
    // console.warn(error);
  }
}

